import { PAGE } from "./actions";
import CONSTANTS from "../constants";
const reducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case PAGE:
      return {
        ...state,
        PAGE: payload,
      };
    default:
      return { ...state };
  }
};
const defaultState = {
  PAGE: CONSTANTS.BACKGROUND,
};
export default reducer;
